var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1270_9013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6 0.550049L4.50001 7.65005C4.45001 7.70005 4.40001 7.80005 4.35001 7.85005L3.50001 10.85C3.45001 11.0001 3.50001 11.2001 3.65001 11.35C3.80001 11.4501 3.95001 11.5 4.15001 11.5L7.10001 10.65C7.20001 10.65 7.25001 10.6 7.30001 10.5L14.4 3.40005C15.15 2.60005 15.15 1.35005 14.4 0.550049C13.6 -0.199951 12.4 -0.199951 11.6 0.550049ZM6.95001 9.40005L5.55001 8.00005L11.4 2.20005L12.8 3.60005L6.95001 9.40005ZM5.10001 8.95005L6.00001 9.85005L4.70001 10.2L5.10001 8.95005ZM13.7 2.70005L13.5 2.90005L12.1 1.50005L12.3 1.30005C12.7 0.900049 13.3 0.900049 13.7 1.30005C14.1 1.65005 14.1 2.30005 13.7 2.70005Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15H11C11.85 15 12.5 14.35 12.5 13.5V8C12.5 7.7 12.3 7.5 12 7.5C11.7 7.5 11.5 7.7 11.5 8V13.5C11.5 13.8 11.3 14 11 14H1.5C1.2 14 1 13.8 1 13.5V4C1 3.7 1.2 3.5 1.5 3.5H7C7.3 3.5 7.5 3.3 7.5 3C7.5 2.7 7.3 2.5 7 2.5H1.5C0.65 2.5 0 3.15 0 4V13.5C0 14.3 0.65 15 1.5 15Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1270_9013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4b29f78d291d53ff410bb0c95dbf74a1.svg";
export { ForwardRef as ReactComponent };